import { SuggestionAction, SuggestionState } from 'store/data/suggestion';
import { domainUtility } from 'utility';

const initialState: SuggestionState = { allIds: [], byId: {} };

const suggestionReducer = (
  state: SuggestionState = initialState,
  action: SuggestionAction,
): SuggestionState => {
  switch (action.type) {
    case 'data/suggestion/ADD':
      return domainUtility.add(state, action.payload);
    case 'data/suggestion/SET':
      return domainUtility.set(state, action.payload);
    case 'data/suggestion/UPDATE':
      return domainUtility.update(state, action.payload);
    case 'data/suggestion/REMOVE':
      return domainUtility.remove(state, action.payload);
    case 'data/suggestion/SET_DOMAIN': {
      const { allIds, byId } = action.payload;
      return { allIds, byId };
    }
    default:
      return state;
  }
};

export default suggestionReducer;
